import { createFileRoute } from '@tanstack/react-router'

import { UnsExplorer } from '@/components/UnsExplorer'

export const Route = createFileRoute('/_app/energy/explorer')({
  component: EnergyExplorerPage,
})

const ENERGY_TOPIC_FILTERS = ['ecorp/generation/#', 'ecorp/storage/#']

function EnergyExplorerPage() {
  return (
    <UnsExplorer
      wsAddress={import.meta.env.VITE_SHARED_WS_ADDRESS}
      username={import.meta.env.VITE_ENERGY_WS_USERNAME}
      password={import.meta.env.VITE_ENERGY_WS_PASSWORD}
      rootName="Energy"
      topicFilters={ENERGY_TOPIC_FILTERS}
      clientIdPrefix="stories_uns_energy"
    />
  )
}
